import config from "config/config";
import { authService } from "./authService";
import { TeamFilters } from "redux/Ldb/types/teamTypes";
import { createUrlSearchParams } from "helpers/createUrlSearchParam";

export const teamService = {
    getTeamMembers,
    getTeamMembers2,
};

async function getTeamMembers(
    teamLimit: number | string,
    search?: string,
    page?: number,
    token?: string
) {
    const requestOptions: { [key: string]: any } = {
        method: "GET",
    };

    const urlParams = new URLSearchParams();
    if (page) urlParams.append("page", page.toString());
    if (search) urlParams.append("search", search);

    if (token) {
        requestOptions.headers = {
            Authorization: `Bearer ${token}`,
        };
    }

    const res = await authService.apiGate(
        `${config.API_URL}/api/v1/ldb/team?limit=${teamLimit}${
            Boolean(urlParams?.toString()) ? "&" + urlParams?.toString() : ""
        }`,
        requestOptions
    );
    return res;
}

async function getTeamMembers2(filters?: TeamFilters, token?: string) {
    try {
        const requestOptions: { [key: string]: any } = {
            method: "GET",
        };

        const urlParams = createUrlSearchParams({
            ...filters,
        });

        if (token) {
            requestOptions.headers = {
                Authorization: `Bearer ${token}`,
            };
        }

        const res = await authService.apiGate(
            `${config.API_URL}/api/v1/ldb/team?${urlParams.toString()}`,
            requestOptions
        );
        return res;
    } catch (error) {
        console.error("Error fetching team members:", error);
        throw error;
    }
}
